exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit__heading,\n.edit__subheading {\n  text-align: center;\n}", ""]);

// exports
